import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import DeviceSelector from '../components/DeviceSelector'
import RepairSelector from '../components/RepairSelector'
import { Device } from '../types'

const RepairPage: React.FC = () => {
  const [selectedDevice, setSelectedDevice] = useState<Device | undefined>(undefined)
  const location = useLocation()

  // Reset selectedDevice when reset query parameter is present
  // Or auto-select diagnosis device when diagnosis parameter is present
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    if (searchParams.has('reset')) {
      setSelectedDevice(undefined)
    } else if (searchParams.has('diagnosis')) {
      // Auto-select first available diagnosis device
      fetch('/api/devices')
        .then(res => res.json())
        .then(devices => {
          const diagnosisDevice = devices.find((device: Device) =>
            device.deviceModel === 'Gerät-Diagnose'
          )
          if (diagnosisDevice) {
            setSelectedDevice(diagnosisDevice)
          }
        })
        .catch(err => console.error('Error fetching diagnosis device:', err))
    }
  }, [location.search])

  const handleDeviceSelect = (device: Device) => {
    setSelectedDevice(device)
  }

  const handleBack = () => {
    setSelectedDevice(undefined)
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        {!selectedDevice ? (
          <DeviceSelector 
            onDeviceSelect={handleDeviceSelect} 
            selectedDevice={selectedDevice}
          />
        ) : (
          <RepairSelector 
            device={selectedDevice} 
            onBack={handleBack}
          />
        )}
      </div>
    </div>
  )
}

export default RepairPage